import { render, staticRenderFns } from "./FenceTutorial.vue?vue&type=template&id=0bc9915b&scoped=true&"
import script from "./FenceTutorial.vue?vue&type=script&lang=js&"
export * from "./FenceTutorial.vue?vue&type=script&lang=js&"
import style0 from "./FenceTutorial.vue?vue&type=style&index=0&id=0bc9915b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc9915b",
  null
  
)

export default component.exports